module.exports = __webpack_public_path__ + "media/images/home/logo-roku-white-f76b3e8736f8136c55dde7a3c49bbea6.svg";